import defaultClient from '@/plugins/axios/defaultClient'

export default {
  async getTerms() {
    return defaultClient.get('/terms')
  },
  async getTermsDetail({ uuid }) {
    return defaultClient.get(`/terms/${uuid}`)
  },
}
